import { kebabCase } from 'lodash'

import { FaqEntriesResp } from 'types/api/response/faq-entries-resp'
import { FaqEntryDto } from 'types/dtos/faq-entry'
import { HelpCenterFaqEntryRubyDto } from 'types/dtos/help-center'
import { FaqEntryModel } from 'types/models/faq-entry'
import {
  HelpCenterFaqEntryRubyModel,
  HelpCenterHomeFaqEntryModel,
  HelpCenterNavigationItemModel,
  HelpCenterNavigationModel,
  HelpCenterQuestionModel,
} from 'types/models/help-center'

const transformHomeFaqEntryDto = (faq: Omit<FaqEntryDto, 'body'>): HelpCenterHomeFaqEntryModel => ({
  id: faq.id,
  title: faq.title,
  icon: faq.icon,
})

export const transformHelpCenterHomeFaqsResponse = (response: FaqEntriesResp) =>
  response.faq_entries.map(transformHomeFaqEntryDto)

const transformHelpCenterNavigationDto = ({
  id,
  title,
  children,
}: Pick<FaqEntryDto, 'id' | 'title' | 'children'>): HelpCenterNavigationItemModel => ({
  id,
  title: title || null,
  childFaqEntries: children?.map(childFaqEntry => ({
    ...transformHelpCenterNavigationDto(childFaqEntry),
    faqEntryParentId: id,
  })),
})

export const transformHelpCenterNavigationResponse = ({
  faq_entries_parent_id,
  faq_entries_parent_title,
  faq_entries,
}: FaqEntriesResp): HelpCenterNavigationModel => ({
  rootFaqEntryId: faq_entries_parent_id,
  rootFaqEntryTitle: faq_entries_parent_title,
  childFaqEntries: faq_entries.map(transformHelpCenterNavigationDto),
})

export const transformHelpCenterFaqEntryRubyDto = (
  faqEntry: HelpCenterFaqEntryRubyDto,
): HelpCenterFaqEntryRubyModel => ({
  id: faqEntry.id,
  title: faqEntry.title,
  code: faqEntry.code,
  proceedButton: faqEntry.proceed_button,
  isContactAllowed: faqEntry.contact_allowed,
  isAnonymousAllowed: faqEntry.anonymous_allowed,
  isTransactionRequired: faqEntry.transaction_required,
  isComplaintsFaq: faqEntry.delays_ticket,
})

export const transformHelpCenterFaqEntryChildren = (
  { children }: FaqEntryModel,
  accessChannel: string,
  faqEntryParentId?: number | null,
  transactionId?: string,
): Array<HelpCenterQuestionModel> | null => {
  if (!children?.length) return null
  const pathPrefix = faqEntryParentId ? `/help/${faqEntryParentId}` : '/help'

  return children.map(({ id, title }) => {
    const mainPath = `${pathPrefix}/${kebabCase(`${id}-${title}`)}?access_channel=${accessChannel}`
    const path = transactionId ? `${mainPath}&transaction_id=${transactionId}` : mainPath

    return { id, title, path }
  })
}
